import {isServer} from 'coreUtils/utils';

const useTouchDevice = () => {
	if (!isServer) {
		let isEventTouch = 'ontouchstart' in window;

		if (!isEventTouch && 'DocumentTouch' in window) {
			isEventTouch = document instanceof (window as any)['DocumentTouch'];
		}

		return isEventTouch || navigator.maxTouchPoints > 0 || (window.navigator as any).msMaxTouchPoints > 0;
	}

	return false;
};

export default useTouchDevice;
